import { Component, Input, TemplateRef } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgTemplateOutlet } from '@angular/common';
import { DynamicFieldModel } from '../../../index';
import { Textarea } from 'primeng/textarea';

@Component({
  selector: 'shared-ui-dynamic-form-textarea',
  imports: [ReactiveFormsModule, NgTemplateOutlet, Textarea],
  template: `
    @if (template) {
      <ng-container
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{ fieldModel }"></ng-container>
    } @else {
      <textarea pTextarea [formControl]="fieldModel.control!"></textarea>
    }
  `,
  styles: ``,
})
export class DynamicFormTextareComponent {
  @Input() template?: TemplateRef<unknown>;
  @Input({ required: true }) fieldModel!: DynamicFieldModel;
}
